
// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const BackButton = styled.div`
//   background: #2F5C94;
//   color: #fff;
//   padding: 12px 20px;
//   font-weight: bold;
//   font-size: 1rem;
//   text-align: center;
//   cursor: pointer;
//   width: 100%;
//   box-sizing: border-box;
  
//   &:hover {
//     background: #5a8a7a;
//   }
  
//   @media (max-width: 768px) {
//     padding: 10px 15px;
//     font-size: 0.95rem;
//   }
  
//   @media (max-width: 480px) {
//     padding: 8px 12px;
//     font-size: 0.85rem;
    
//   }
// `;

// const Container = styled.div`
//   background: #e8e8e8;
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   width: 100%;
//   box-sizing: border-box;
//   padding: 10px 0 80px 0;
  
//   @media (max-width: 768px) {
//     padding: 0px 0 80px 0;
//   }
// `;

// const MatchCard = styled.div`
//   background: #fff;
//   margin: 6px auto;
//   border-radius: 4px;
//   overflow: hidden;
//   box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//   width: 90%;
//   max-width: 1000px;
  
//   @media (max-width: 768px) {
//     width: 95%;
//     margin: 5px auto;
//   }
  
//   @media (max-width: 480px) {
//     width: 98%;
//     margin: 4px auto;
//   }
// `;

// const MatchHeader = styled.div`
//   background: #FF0266;
//   color: #fff;
//   padding: 10px 20px;
//   font-weight: bold;
//   font-size: 1rem;
//   cursor: pointer;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   position: relative;
  
//   @media (max-width: 768px) {
//     padding: 8px 15px;
//     font-size: 0.95rem;
//   }
  
//   @media (max-width: 480px) {
//     padding: 8px 12px;
//     font-size: 0.85rem;
//   }
// `;

// const MatchTitle = styled.div`
//   text-align: center;
//   flex: 1;
// `;

// const ExpandIcon = styled.span`
//   display: none;
// `;

// const MatchInfo = styled.div`
//   background: #f5f5f5;
//   padding: 10px 20px;
//   color: #222;
//   font-size: 0.9rem;
//   line-height: 1.5;
  
//   @media (max-width: 768px) {
//     padding: 8px 15px;
//     font-size: 0.85rem;
//     line-height: 1.4;

//   }
  
//   @media (max-width: 480px) {
//     padding: 8px 12px;
//     font-size: 0.8rem;
//     line-height: 1.3;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//    flex-direction: column;
//   }
// `;

// const InfoRow = styled.div`
//   display: flex;
//   margin-bottom: 4px;
  
//   &:last-child {
//     margin-bottom: 0;
//   }
// `;

// const InfoLabel = styled.span`
//   font-weight: 600;
//   color: #333;
//   font-size: 0.9rem;
  
//   @media (max-width: 480px) {
//     font-size: 0.8rem;
//   }
// `;

// const InfoValue = styled.span`
//   color: #222;
//   font-size: 0.9rem;
  
//   @media (max-width: 480px) {
//     font-size: 0.8rem;
//   }
// `;

// const CoinsLost = styled.span`
//   color: ${props => props.value < 0 ? '#dc3545' : '#28a745'};
//   font-weight: 600;
//   font-size: 0.9rem;
  
//   @media (max-width: 480px) {
//     font-size: 0.8rem;
//   }
// `;

// const MatchContent = styled.div`
//   overflow: hidden;
//   max-height: ${props => props.expanded ? '10000px' : '0'};
//   transition: max-height 0.3s ease-out;
//   background: #fff;
// `;

// const BetSection = styled.div`
//   padding: 20px;
//   border-top: 1px solid #e0e0e0;
  
//   @media (max-width: 768px) {
//     padding: 15px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 2px;
//   }
// `;

// const BetSectionTitle = styled.div`
//   background: #8ab7a6;
//   color: #fff;
//   padding: 12px 20px;
//   font-weight: 600;
//   font-size: 1rem;
//   text-align: center;
//   margin-bottom: 15px;
  
//   @media (max-width: 480px) {
//     padding: 3px 15px;
//     font-size: 0.9rem;
//   }
// `;

// const TableWrapper = styled.div`
//   width: 100%;
//   overflow-x: auto;
//   margin-bottom: 20px;
  
//   &:last-child {
//     margin-bottom: 0;
//   }
// `;

// const StyledTable = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   background: #fff;
//   min-width: 100%;
  
//   @media (max-width: 768px) {
//     min-width: 700px;
//   }
// `;

// const StyledThead = styled.thead`
//   background: #8ab7a6;
// `;

// const StyledTh = styled.th`
//   color: #fff;
//   padding: 12px 8px;
//   font-weight: 600;
//   text-align: center;
//   border: 1px solid #b2c8b2;
//   font-size: 0.95rem;
  
//   @media (max-width: 768px) {
//     padding: 10px 6px;
//     font-size: 0.85rem;
//   }
  
//   @media (max-width: 480px) {
//     padding: 8px 4px;
//     font-size: 0.75rem;
//   }
// `;

// const StyledTd = styled.td`
//   padding: 10px 8px;
//   text-align: center;
//   color: #222;
//   font-size: 0.9rem;
//   border: 1px solid #e0e0e0;
//   background: ${props => 
//     props.result === 'win' ? '#d4edda' : 
//     props.result === 'loss' ? '#f8d7da' : 
//     '#fff'};
  
//   @media (max-width: 768px) {
//     padding: 8px 6px;
//     font-size: 0.85rem;
//   }
  
//   @media (max-width: 480px) {
//     padding: 6px 4px;
//     font-size: 0.75rem;
//   }
// `;

// const StyledTr = styled.tr`
//   &:hover {
//     background: #f9f9f9;
//   }
// `;

// const Copyright = styled.div`
//   position: fixed;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   background: #2F5C94;
//   color: #fff;
//   padding: 12px 20px;
//   text-align: center;
//   font-size: 0.9rem;
//   z-index: 100;
  
//   @media (max-width: 480px) {
//     padding: 10px 15px;
//     font-size: 0.8rem;
//   }
// `;

// const EmptyState = styled.div`
//   text-align: center;
//   padding: 60px 20px;
//   color: #666;
//   font-size: 1.1rem;
  
//   @media (max-width: 480px) {
//     padding: 40px 15px;
//     font-size: 1rem;
//   }
// `;


// const Matkahisrty = () => {
//   const navigate = useNavigate();
//   const [userData, setUserData] = useState(null);
//   const [data, setData] = useState([]);
//   const [data2, setAllBets] = useState([]);
//   const [expandedMatches, setExpandedMatches] = useState({});

//   useEffect(() => {
//     const user = localStorage.getItem('user');
//     if (user) {
//       setUserData(JSON.parse(user));
//     } else {
//       alert("User is not logged in. Please log in to view your bets.");
//     }
//   }, []);

//   const fetchBets = async () => {
//     if (userData) {
//       try {
//         const userId = userData.id;
//         const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/laggai_khai_getuserbet/${userId}`);
//         console.log(response.data,"betdata")
//         if (response.data.success) {
//           setData(response.data.bets);
//         } else {
//           alert("Failed to fetch bets");
//         }
//       } catch (err) {
//         console.error('Error fetching bets:', err);
//       }
//     }
//   };

//   useEffect(() => {
//     if (userData) {
//       fetchBets();
//     }
//   }, [userData]);

//   const userId = JSON.parse(localStorage.getItem('user'))?.id;
//   const fetchApi = async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/cricket-market2/${userId}`);
//       console.log(response.data,"betdata")
//       setAllBets(response.data);
//     } catch (err) {
//       console.error('Error fetching bets:', err);
//     }
//   }

//   useEffect(() => {
//     if (userId) {
//       fetchApi();
//     }
//   }, [userId])

//   // Group data by match name with profitloss
//   const lagaiKhaiData = data.map((item) => ({
//     matchname: item.match,
//     label: item.label,
//     type: item.type,
//     stake: item.stake,
//     odds: item.odds,
//     result: item.result,
//     date: item.createdAt,
//     profitloss: item.profitloss || 0,
//     betType: 'lagaiKhai'
//   }));

//   const yesNoData = data2.map((item) => ({
//     matchname: item.matchName,
//     label: item.matbet,
//     type: item.mode,
//     stake: item.stake,
//     odds: item.noRuns || item.yesRuns,
//     result: item.result,
//     date: item.createdAt,
//     profitloss: item.profitloss || 0,
//     betType: 'yesNo',
//     winningRuns: item.winningRuns,
//     yesRuns: item.yesRuns,
//     noRuns: item.noRuns
//   }));

//   // Group by match name
//   const groupedByMatch = {};
  
//   [...lagaiKhaiData, ...yesNoData].forEach((bet) => {
//     const matchName = bet.matchname || 'Unknown Match';
//     if (!groupedByMatch[matchName]) {
//       groupedByMatch[matchName] = {
//         lagaiKhai: [],
//         yesNo: [],
//         totalProfitLoss: 0,
//         latestDate: null,
//         winner: null
//       };
//     }
//     if (bet.betType === 'lagaiKhai') {
//       groupedByMatch[matchName].lagaiKhai.push(bet);
//     } else {
//       groupedByMatch[matchName].yesNo.push(bet);
//     }
    
//     // Calculate total profitloss
//     groupedByMatch[matchName].totalProfitLoss += parseFloat(bet.profitloss) || 0;
    
//     // Track latest date
//     const betDate = new Date(bet.date);
//     if (!groupedByMatch[matchName].latestDate || betDate > groupedByMatch[matchName].latestDate) {
//       groupedByMatch[matchName].latestDate = betDate;
//     }
    
//     // Determine winner from yes/no bets
//     if (bet.betType === 'yesNo' && bet.result === 'win') {
//       // Extract team name from match name or label
//       const matchParts = bet.matchname?.split(' v ') || [];
//       if (matchParts.length >= 2) {
//         // Try to determine winner from the bet
//         if (bet.label && bet.label.includes('RUN')) {
//           // For session bets, winner is determined by result
//           // This is a simplified logic - you may need to adjust based on your data structure
//           groupedByMatch[matchName].winner = bet.label;
//         }
//       }
//     }
//   });

//   // Sort bets within each match by date (newest first) and combine
//   Object.keys(groupedByMatch).forEach(matchName => {
//     groupedByMatch[matchName].lagaiKhai.sort((a, b) => new Date(b.date) - new Date(a.date));
//     groupedByMatch[matchName].yesNo.sort((a, b) => new Date(b.date) - new Date(a.date));
//     // Pre-sort all bets for this match
//     groupedByMatch[matchName].allBets = [...groupedByMatch[matchName].lagaiKhai, ...groupedByMatch[matchName].yesNo]
//       .sort((a, b) => new Date(b.date) - new Date(a.date));
//   });

//   // Get unique match names sorted by most recent bet date
//   const uniqueMatches = Object.keys(groupedByMatch).sort((a, b) => {
//     const aDate = groupedByMatch[a].latestDate || new Date(0);
//     const bDate = groupedByMatch[b].latestDate || new Date(0);
//     return bDate - aDate;
//   });

//   const toggleMatch = (matchName) => {
//     setExpandedMatches(prev => ({
//       ...prev,
//       [matchName]: !prev[matchName]
//     }));
//   };

//   // Helper function to determine winner text
//   const getWinnerText = (matchName, matchData) => {
//     // Check if there are any winning bets
//     const allBets = [...matchData.lagaiKhai, ...matchData.yesNo];
//     const winningBets = allBets.filter(bet => bet.result === 'win');
    
//     if (winningBets.length > 0) {
//       // For lagaiKhai bets, winner is the label
//       const lagaiWin = winningBets.find(bet => bet.betType === 'lagaiKhai');
//       if (lagaiWin) {
//         return `${lagaiWin.label} Win The Match`;
//       }
      
//       // For yes/no bets, determine from match name
//       const matchParts = matchName.split(' v ');
//       if (matchParts.length >= 2) {
//         // This is simplified - you may need to adjust based on actual winner determination logic
//         return `${matchParts[0]} Win The Match`;
//       }
//     }
    
//     // Default fallback
//     const matchParts = matchName.split(' v ');
//     if (matchParts.length >= 2) {
//       return `${matchParts[0]} Win The Match`;
//     }
//     return 'Match Declared';
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     const hours = String(date.getHours()).padStart(2, '0');
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const ampm = hours >= 12 ? 'PM' : 'AM';
//     const displayHours = hours % 12 || 12;
//     return `${year}-${month}-${day}, ${displayHours}:${minutes} ${ampm}`;
//   };

//   return (
//     <>
//       <BackButton onClick={() => navigate('/')}>
//         BACK TO MAIN MENU
//       </BackButton>
//       <Container>
//         {uniqueMatches.length === 0 ? (
//           <EmptyState>No cricket history found</EmptyState>
//         ) : (
//           uniqueMatches.map((matchName) => {
//             const matchData = groupedByMatch[matchName];
//             const isExpanded = expandedMatches[matchName];
//             const allBets = matchData.allBets || [];
//             const latestBet = allBets[0] || null;
//             const totalProfitLoss = matchData.totalProfitLoss;

//             return (
//               <MatchCard key={matchName}>
//                 <MatchHeader onClick={() => toggleMatch(matchName)}>
//                   <MatchTitle>{matchName} 👁️ </MatchTitle>
//                   <ExpandIcon expanded={isExpanded}>▼</ExpandIcon>
//                 </MatchHeader>
                
//                 <MatchInfo>
//                   <InfoRow>
                    
//                     <InfoValue>{latestBet ? formatDate(latestBet.date) : '-'}</InfoValue>
//                   </InfoRow>
//                   <InfoRow>
                   
//                     <InfoValue>Declared: Yes</InfoValue>
//                   </InfoRow>
//                   <InfoRow>
//                     <InfoValue>Won By: {getWinnerText(matchName, matchData)}</InfoValue>
//                   </InfoRow>
//                   <InfoRow>
//                     <InfoLabel>{totalProfitLoss < 0 ? 'Lost Coins:' : 'Won Coins:'}</InfoLabel>
//                     <CoinsLost value={totalProfitLoss}>
//                       {totalProfitLoss < 0 ? totalProfitLoss : `+${totalProfitLoss}`}
//                     </CoinsLost>
//                   </InfoRow>
//                 </MatchInfo>
                
//                 <MatchContent expanded={isExpanded}>
//                   {matchData.yesNo.length > 0 && (
//                     <BetSection>
//                       <BetSectionTitle>Session Bets (Yes/No)</BetSectionTitle>
//                       <TableWrapper>
//                         <StyledTable>
//                           <StyledThead>
//                             <tr>
//                               <StyledTh>Bet</StyledTh>
//                               <StyledTh>Type</StyledTh>
//                               <StyledTh>Stake</StyledTh>
//                               <StyledTh>Odds</StyledTh>
//                               <StyledTh>Result</StyledTh>
//                               <StyledTh>Profit/Loss</StyledTh>
//                               <StyledTh>Date</StyledTh>
//                             </tr>
//                           </StyledThead>
//                           <tbody>
//                             {matchData.yesNo.map((bet, index) => (
//                               <StyledTr key={`yesno-${index}`}>
//                                 <StyledTd result={bet.result}>{bet.label || '-'}</StyledTd>
//                                 <StyledTd result={bet.result}>{bet.type || '-'}</StyledTd>
//                                 <StyledTd result={bet.result}>{bet.stake || '-'}</StyledTd>
//                                 <StyledTd result={bet.result}>{bet.odds || '-'}</StyledTd>
//                                 <StyledTd result={bet.result}>
//                                   <span style={{ 
//                                     color: bet.result === 'win' ? '#28a745' : bet.result === 'loss' ? '#dc3545' : '#6c757d',
//                                     fontWeight: '600'
//                                   }}>
//                                     {bet.result || '-'}
//                                   </span>
//                                 </StyledTd>
//                                 <StyledTd result={bet.result}>
//                                   <span style={{ 
//                                     color: (bet.profitloss || 0) < 0 ? '#dc3545' : '#28a745',
//                                     fontWeight: '600'
//                                   }}>
//                                     {bet.profitloss || 0}
//                                   </span>
//                                 </StyledTd>
//                                 <StyledTd result={bet.result}>{formatDate(bet.date)}</StyledTd>
//                               </StyledTr>
//                             ))}
//                           </tbody>
//                         </StyledTable>
//                       </TableWrapper>
//                     </BetSection>
//                   )}
                  
//                   {matchData.lagaiKhai.length > 0 && (
//                     <BetSection>
//                       <BetSectionTitle>Lagai Khai Bets</BetSectionTitle>
//                       <TableWrapper>
//                         <StyledTable>
//                           <StyledThead>
//                             <tr>
//                               <StyledTh>Bet</StyledTh>
//                               <StyledTh>Type</StyledTh>
//                               <StyledTh>Stake</StyledTh>
//                               <StyledTh>Odds</StyledTh>
//                               <StyledTh>Result</StyledTh>
//                               <StyledTh>Profit/Loss</StyledTh>
//                               <StyledTh>Date</StyledTh>
//                             </tr>
//                           </StyledThead>
//                           <tbody>
//                             {matchData.lagaiKhai.map((bet, index) => (
//                               <StyledTr key={`lagai-${index}`}>
//                                 <StyledTd result={bet.result}>{bet.label || '-'}</StyledTd>
//                                 <StyledTd result={bet.result}>{bet.type || '-'}</StyledTd>
//                                 <StyledTd result={bet.result}>{bet.stake || '-'}</StyledTd>
//                                 <StyledTd result={bet.result}>{bet.odds || '-'}</StyledTd>
//                                 <StyledTd result={bet.result}>
//                                   <span style={{ 
//                                     color: bet.result === 'win' ? '#28a745' : bet.result === 'loss' ? '#dc3545' : '#6c757d',
//                                     fontWeight: '600'
//                                   }}>
//                                     {bet.result || '-'}
//                                   </span>
//                                 </StyledTd>
//                                 <StyledTd result={bet.result}>
//                                   <span style={{ 
//                                     color: (bet.profitloss || 0) < 0 ? '#dc3545' : '#28a745',
//                                     fontWeight: '600'
//                                   }}>
//                                     {bet.profitloss || 0}
//                                   </span>
//                                 </StyledTd>
//                                 <StyledTd result={bet.result}>{formatDate(bet.date)}</StyledTd>
//                               </StyledTr>
//                             ))}
//                           </tbody>
//                         </StyledTable>
//                       </TableWrapper>
//                     </BetSection>
//                   )}
                  
//                   {matchData.yesNo.length === 0 && matchData.lagaiKhai.length === 0 && (
//                     <BetSection>
//                       <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
//                         No bets found for this match
//                       </div>
//                     </BetSection>
//                   )}
//                 </MatchContent>
//               </MatchCard>
//             );
//           })
//         )}
//       </Container>
//       <Copyright>Copy Right @YOX9.COM</Copyright>
//     </>
//   );
// };

// export default Matkahisrty;




import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import defaultLogo from "../assets/frontimges/default.jpg";
import default2Logo from "../assets/frontimges/default2.jpg";

const BackButton = styled.div`
  background: #2F5C94;
  color: #fff;
  padding: 12px 20px;
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  
  &:hover {
    background: #5a8a7a;
  }
  
  @media (max-width: 768px) {
    padding: 10px 15px;
    font-size: 0.95rem;
  }
  
  @media (max-width: 480px) {
    padding: 8px 12px;
    font-size: 0.85rem;
    
  }
`;

const Container = styled.div`
  background: #e8e8e8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0 80px 0;
  
  @media (max-width: 768px) {
    padding: 0px 0 80px 0;
  }
`;

const MatchCard = styled.div`
  background: #fff;
  margin: 6px auto;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  width: 90%;
  max-width: 1000px;
  
  @media (max-width: 768px) {
    width: 95%;
    margin: 5px auto;
  }
  
  @media (max-width: 480px) {
    width: 98%;
    margin: 4px auto;
  }
`;

const MatchHeader = styled.div`
  background: rgb(7, 77, 143);
  color: #fff;
  padding: 10px 20px;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 8px 15px;
    font-size: 0.95rem;
  }
  
  @media (max-width: 480px) {
    padding: 8px 12px;
    font-size: 0.85rem;
  }
`;

const MatchTitle = styled.div`
  text-align: center;
  flex: 1;
`;

const ExpandIcon = styled.span`
  display: none;
`;

const MatchInfo = styled.div`
  background: #f5f5f5;
  padding: 10px 20px;
  color: #222;
  font-size: 0.9rem;
  line-height: 1.5;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  
  @media (max-width: 768px) {
    padding: 8px 15px;
    font-size: 0.85rem;
    line-height: 1.4;
    gap: 15px;
    flex-direction: row;
  }
  
  @media (max-width: 480px) {
    padding: 0px 0px;
    font-size: 0.8rem;
    line-height: 1.3;
   
    gap: 00px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
 
  
  padding: 8px;
  width: 100px;
  height: 100px;
  min-width: 100px;
  
  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
    min-width: 80px;
    padding: 6px;
  }
  
  @media (max-width: 480px) {
    width: 70px;
    height: 70px;
    min-width: 70px;
    padding: 5px;
  }
`;

const TeamLogo = styled.img`
  width: 70%;
  height: 70%;
  object-fit: contain;

`;

const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 0;
  
  @media (max-width: 480px) {
    width: 100%;
  }
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  text-align: center;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const InfoLabel = styled.span`
  font-weight: 600;
  color: #000;
  font-size: 0.9rem;
  
  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const InfoValue = styled.span`
  color: #000;
  font-size: 0.9rem;
  font-weight: 600;
  
  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const InfoValueBlue = styled.span`
  color: #0066cc;
  font-size: 0.9rem;
  font-weight: 600;
  margin-left: 4px;
  
  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const CoinsLost = styled.span`
  color: ${props => props.value < 0 ? '#dc3545' : '#28a745'};
  font-weight: 600;
  font-size: 0.9rem;
  
  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const MatchContent = styled.div`
  overflow: hidden;
  max-height: ${props => props.expanded ? '10000px' : '0'};
  transition: max-height 0.3s ease-out;
  background: #fff;
`;

const BetSection = styled.div`
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  
  @media (max-width: 768px) {
    padding: 15px;
  }
  
  @media (max-width: 480px) {
    padding: 2px;
  }
`;

const BetSectionTitle = styled.div`
  background: #8ab7a6;
  color: #fff;
  padding: 12px 20px;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
  margin-bottom: 15px;
  
  @media (max-width: 480px) {
    padding: 3px 15px;
    font-size: 0.9rem;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  min-width: 100%;
  
  @media (max-width: 768px) {
    min-width: 700px;
  }
`;

const StyledThead = styled.thead`
  background: #8ab7a6;
`;

const StyledTh = styled.th`
  color: #fff;
  padding: 12px 8px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #b2c8b2;
  font-size: 0.95rem;
  
  @media (max-width: 768px) {
    padding: 10px 6px;
    font-size: 0.85rem;
  }
  
  @media (max-width: 480px) {
    padding: 8px 4px;
    font-size: 0.75rem;
  }
`;

const StyledTd = styled.td`
  padding: 10px 8px;
  text-align: center;
  color: #222;
  font-size: 0.9rem;
  border: 1px solid #e0e0e0;
  background: ${props => 
    props.result === 'win' ? '#d4edda' : 
    props.result === 'loss' ? '#f8d7da' : 
    '#fff'};
  
  @media (max-width: 768px) {
    padding: 8px 6px;
    font-size: 0.85rem;
  }
  
  @media (max-width: 480px) {
    padding: 6px 4px;
    font-size: 0.75rem;
  }
`;

const StyledTr = styled.tr`
  &:hover {
    background: #f9f9f9;
  }
`;

const Copyright = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2F5C94;
  color: #fff;
  padding: 12px 20px;
  text-align: center;
  font-size: 0.9rem;
  z-index: 100;
  
  @media (max-width: 480px) {
    padding: 10px 15px;
    font-size: 0.8rem;
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #666;
  font-size: 1.1rem;
  
  @media (max-width: 480px) {
    padding: 40px 15px;
    font-size: 1rem;
  }
`;


const Matkahisrty = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [data, setData] = useState([]);
  const [data2, setAllBets] = useState([]);
  const [expandedMatches, setExpandedMatches] = useState({});

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setUserData(JSON.parse(user));
    } else {
      alert("User is not logged in. Please log in to view your bets.");
    }
  }, []);

  const fetchBets = async () => {
    if (userData) {
      try {
        const userId = userData.id;
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/laggai_khai_getuserbet/${userId}`);
        console.log(response.data,"betdata")
        if (response.data.success) {
          setData(response.data.bets);
        } else {
          alert("Failed to fetch bets");
        }
      } catch (err) {
        console.error('Error fetching bets:', err);
      }
    }
  };

  useEffect(() => {
    if (userData) {
      fetchBets();
    }
  }, [userData]);

  const userId = JSON.parse(localStorage.getItem('user'))?.id;
  const fetchApi = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/cricket-market2/${userId}`);
      console.log(response.data,"betdata")
      setAllBets(response.data);
    } catch (err) {
      console.error('Error fetching bets:', err);
    }
  }

  useEffect(() => {
    if (userId) {
      fetchApi();
    }
  }, [userId])

  // Group data by match name with profitloss
  const lagaiKhaiData = data.map((item) => ({
    matchname: item.match,
    label: item.label,
    type: item.type,
    stake: item.stake,
    odds: item.odds,
    result: item.result,
    date: item.createdAt,
    profitloss: item.profitloss || 0,
    betType: 'lagaiKhai'
  }));

  const yesNoData = data2.map((item) => ({
    matchname: item.matchName,
    label: item.matbet,
    type: item.mode,
    stake: item.stake,
    odds: item.noRuns || item.yesRuns,
    result: item.result,
    date: item.createdAt,
    profitloss: item.profitloss || 0,
    betType: 'yesNo',
    winningRuns: item.winningRuns,
    yesRuns: item.yesRuns,
    noRuns: item.noRuns
  }));

  // Group by match name
  const groupedByMatch = {};
  
  [...lagaiKhaiData, ...yesNoData].forEach((bet) => {
    const matchName = bet.matchname || 'Unknown Match';
    if (!groupedByMatch[matchName]) {
      groupedByMatch[matchName] = {
        lagaiKhai: [],
        yesNo: [],
        totalProfitLoss: 0,
        latestDate: null,
        winner: null
      };
    }
    if (bet.betType === 'lagaiKhai') {
      groupedByMatch[matchName].lagaiKhai.push(bet);
    } else {
      groupedByMatch[matchName].yesNo.push(bet);
    }
    
    // Calculate total profitloss
    groupedByMatch[matchName].totalProfitLoss += parseFloat(bet.profitloss) || 0;
    
    // Track latest date
    const betDate = new Date(bet.date);
    if (!groupedByMatch[matchName].latestDate || betDate > groupedByMatch[matchName].latestDate) {
      groupedByMatch[matchName].latestDate = betDate;
    }
    
    // Determine winner from yes/no bets
    if (bet.betType === 'yesNo' && bet.result === 'win') {
      // Extract team name from match name or label
      const matchParts = bet.matchname?.split(' v ') || [];
      if (matchParts.length >= 2) {
        // Try to determine winner from the bet
        if (bet.label && bet.label.includes('RUN')) {
          // For session bets, winner is determined by result
          // This is a simplified logic - you may need to adjust based on your data structure
          groupedByMatch[matchName].winner = bet.label;
        }
      }
    }
  });

  // Sort bets within each match by date (newest first) and combine
  Object.keys(groupedByMatch).forEach(matchName => {
    groupedByMatch[matchName].lagaiKhai.sort((a, b) => new Date(b.date) - new Date(a.date));
    groupedByMatch[matchName].yesNo.sort((a, b) => new Date(b.date) - new Date(a.date));
    // Pre-sort all bets for this match
    groupedByMatch[matchName].allBets = [...groupedByMatch[matchName].lagaiKhai, ...groupedByMatch[matchName].yesNo]
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  });

  // Get unique match names sorted by most recent bet date
  const uniqueMatches = Object.keys(groupedByMatch).sort((a, b) => {
    const aDate = groupedByMatch[a].latestDate || new Date(0);
    const bDate = groupedByMatch[b].latestDate || new Date(0);
    return bDate - aDate;
  });

  const toggleMatch = (matchName) => {
    setExpandedMatches(prev => ({
      ...prev,
      [matchName]: !prev[matchName]
    }));
  };

  // Helper function to determine winner text
  const getWinnerText = (matchName, matchData) => {
    // Check if there are any winning bets
    const allBets = [...matchData.lagaiKhai, ...matchData.yesNo];
    const winningBets = allBets.filter(bet => bet.result === 'win');
    
    if (winningBets.length > 0) {
      // For lagaiKhai bets, winner is the label
      const lagaiWin = winningBets.find(bet => bet.betType === 'lagaiKhai');
      if (lagaiWin) {
        return `${lagaiWin.label} Win The Match`;
      }
      
      // For yes/no bets, determine from match name
      const matchParts = matchName.split(' v ');
      if (matchParts.length >= 2) {
        // This is simplified - you may need to adjust based on actual winner determination logic
        return `${matchParts[0]} Win The Match`;
      }
    }
    
    // Default fallback
    const matchParts = matchName.split(' v ');
    if (matchParts.length >= 2) {
      return `${matchParts[0]} Win The Match`;
    }
    return 'Match Declared';
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${day}-${month}-${year} ${displayHours}:${minutes} ${ampm}`;
  };

  return (
    <>
      <BackButton onClick={() => navigate('/')}>
        BACK TO MAIN MENU
      </BackButton>
      <Container>
        {uniqueMatches.length === 0 ? (
          <EmptyState>No cricket history found</EmptyState>
        ) : (
          uniqueMatches.map((matchName) => {
            const matchData = groupedByMatch[matchName];
            const isExpanded = expandedMatches[matchName];
            const allBets = matchData.allBets || [];
            const latestBet = allBets[0] || null;
            const totalProfitLoss = matchData.totalProfitLoss;

            return (
              <MatchCard key={matchName}>
                <MatchHeader onClick={() => toggleMatch(matchName)}>
                  <MatchTitle>{matchName} 👁️ </MatchTitle>
                  <ExpandIcon expanded={isExpanded}>▼</ExpandIcon>
                </MatchHeader>
                
                <MatchInfo>
                  <LogoContainer>
                    <TeamLogo src={defaultLogo} alt="Team 1" />
                  </LogoContainer>
                  <InfoContainer>
                    <InfoRow>
                      <InfoValue>{latestBet ? formatDate(latestBet.date) : '-'}</InfoValue>
                    </InfoRow>
                    <InfoRow>
                      <InfoValue>Match Bets : <InfoValueBlue>{matchData.lagaiKhai.length}</InfoValueBlue></InfoValue>
                    </InfoRow>
                    <InfoRow>
                      <InfoValue>Session Bets : <InfoValueBlue>{matchData.yesNo.length}</InfoValueBlue></InfoValue>
                    </InfoRow>
                    <InfoRow>
                      <InfoValue>Declared : <InfoValueBlue>Yes</InfoValueBlue></InfoValue>
                    </InfoRow>
                    <InfoRow>
                      <InfoValue>Won By : <InfoValueBlue>{getWinnerText(matchName, matchData)}</InfoValueBlue></InfoValue>
                    </InfoRow>
                  </InfoContainer>
                  <LogoContainer>
                    <TeamLogo src={default2Logo} alt="Team 2" />
                  </LogoContainer>
                </MatchInfo>
                
                <MatchContent expanded={isExpanded}>
                  {matchData.yesNo.length > 0 && (
                    <BetSection>
                      <BetSectionTitle>Session Bets (Yes/No)</BetSectionTitle>
                      <TableWrapper>
                        <StyledTable>
                          <StyledThead>
                            <tr>
                              <StyledTh>Bet</StyledTh>
                              <StyledTh>Type</StyledTh>
                              <StyledTh>Stake</StyledTh>
                              <StyledTh>Odds</StyledTh>
                              <StyledTh>Result</StyledTh>
                              <StyledTh>Profit/Loss</StyledTh>
                              <StyledTh>Date</StyledTh>
                            </tr>
                          </StyledThead>
                          <tbody>
                            {matchData.yesNo.map((bet, index) => (
                              <StyledTr key={`yesno-${index}`}>
                                <StyledTd result={bet.result}>{bet.label || '-'}</StyledTd>
                                <StyledTd result={bet.result}>{bet.type || '-'}</StyledTd>
                                <StyledTd result={bet.result}>{bet.stake || '-'}</StyledTd>
                                <StyledTd result={bet.result}>{bet.odds || '-'}</StyledTd>
                                <StyledTd result={bet.result}>
                                  <span style={{ 
                                    color: bet.result === 'win' ? '#28a745' : bet.result === 'loss' ? '#dc3545' : '#6c757d',
                                    fontWeight: '600'
                                  }}>
                                    {bet.result || '-'}
                                  </span>
                                </StyledTd>
                                <StyledTd result={bet.result}>
                                  <span style={{ 
                                    color: (bet.profitloss || 0) < 0 ? '#dc3545' : '#28a745',
                                    fontWeight: '600'
                                  }}>
                                    {bet.profitloss || 0}
                                  </span>
                                </StyledTd>
                                <StyledTd result={bet.result}>{formatDate(bet.date)}</StyledTd>
                              </StyledTr>
                            ))}
                          </tbody>
                        </StyledTable>
                      </TableWrapper>
                    </BetSection>
                  )}
                  
                  {matchData.lagaiKhai.length > 0 && (
                    <BetSection>
                      <BetSectionTitle>Lagai Khai Bets</BetSectionTitle>
                      <TableWrapper>
                        <StyledTable>
                          <StyledThead>
                            <tr>
                              <StyledTh>Bet</StyledTh>
                              <StyledTh>Type</StyledTh>
                              <StyledTh>Stake</StyledTh>
                              <StyledTh>Odds</StyledTh>
                              <StyledTh>Result</StyledTh>
                              <StyledTh>Profit/Loss</StyledTh>
                              <StyledTh>Date</StyledTh>
                            </tr>
                          </StyledThead>
                          <tbody>
                            {matchData.lagaiKhai.map((bet, index) => (
                              <StyledTr key={`lagai-${index}`}>
                                <StyledTd result={bet.result}>{bet.label || '-'}</StyledTd>
                                <StyledTd result={bet.result}>{bet.type || '-'}</StyledTd>
                                <StyledTd result={bet.result}>{bet.stake || '-'}</StyledTd>
                                <StyledTd result={bet.result}>{bet.odds || '-'}</StyledTd>
                                <StyledTd result={bet.result}>
                                  <span style={{ 
                                    color: bet.result === 'win' ? '#28a745' : bet.result === 'loss' ? '#dc3545' : '#6c757d',
                                    fontWeight: '600'
                                  }}>
                                    {bet.result || '-'}
                                  </span>
                                </StyledTd>
                                <StyledTd result={bet.result}>
                                  <span style={{ 
                                    color: (bet.profitloss || 0) < 0 ? '#dc3545' : '#28a745',
                                    fontWeight: '600'
                                  }}>
                                    {bet.profitloss || 0}
                                  </span>
                                </StyledTd>
                                <StyledTd result={bet.result}>{formatDate(bet.date)}</StyledTd>
                              </StyledTr>
                            ))}
                          </tbody>
                        </StyledTable>
                      </TableWrapper>
                    </BetSection>
                  )}
                  
                  {matchData.yesNo.length === 0 && matchData.lagaiKhai.length === 0 && (
                    <BetSection>
                      <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                        No bets found for this match
                      </div>
                    </BetSection>
                  )}
                </MatchContent>
              </MatchCard>
            );
          })
        )}
      </Container>
      <Copyright>Copy Right @9xbet24.COM</Copyright>
    </>
  );
};

export default Matkahisrty;



